import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const chiliConCarne: Recipe = {
  slug: 'chili-con-carne',
  title: 'Chili con carne',
  category: 'salé',
  description: 'Un chili mijoté au bœuf, au poivron et aux haricots rouges, pour 4 à 5 personnes.',
  image: image('chili-con-carne'),
  tags: ['bœuf', 'mijoté', 'haricots rouges'],
  meta: [
    { label: 'Préparation', value: '15 min' },
    { label: 'Cuisson', value: 'environ 1 h' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('bœuf', 'viande de bœuf hachée', '500 g de viande de bœuf hachée', {
        amount: 500,
        unit: 'g',
        shoppingKey: 'bœuf haché',
      }),
      ingredient('oignon', 'oignon', '1 gros oignon', { amount: 1, unit: 'oignon', shoppingKey: 'oignon' }),
      ingredient('poivron', 'poivron rouge', '1 poivron rouge', {
        amount: 1,
        unit: 'poivron',
        shoppingKey: 'poivron rouge',
      }),
      ingredient('coulis', 'coulis de tomate', '400 g environ de coulis de tomate', {
        amount: 400,
        unit: 'g',
        shoppingKey: 'coulis de tomate',
      }),
      ingredient('haricots', 'haricots rouges', '1 boîte (environ 400 g) de haricots rouges', {
        amount: 1,
        unit: 'boîte',
        shoppingKey: 'haricots rouges',
      }),
      ingredient('vin-deglacage', 'vin rouge', '10 cl de vin rouge pour déglacer', {
        amount: 10,
        unit: 'cl',
        shoppingKey: 'vin rouge',
      }),
      ingredient('vin-sauce', 'vin rouge', '1 verre de vin rouge à ajouter avec la sauce tomate', {
        shoppingKey: 'vin rouge',
      }),
      ingredient('paprika', 'paprika doux', '1 à 2 c. à café de paprika doux'),
      ingredient('cumin', 'cumin', '1 c. à café de cumin, facultatif', { optional: true }),
      ingredient('piment', 'piment', 'Piment ou piment de Cayenne, selon le goût', { optional: true }),
      ingredient('matiere-grasse', 'huile d’olive et beurre', 'Un peu d’huile d’olive et de beurre'),
      ingredient('assaisonnement', 'sel et poivre', 'Sel, poivre'),
    ]),
  ],
  steps: [
    'Émincer l’oignon et couper le poivron en petits dés.',
    'Faire chauffer un filet d’huile d’olive avec une noix de beurre dans une cocotte. Ajouter en même temps l’oignon, le poivron et la viande hachée, puis faire revenir le tout à feu moyen-vif pendant une dizaine de minutes en émiettant la viande, jusqu’à obtenir une belle coloration et des légumes légèrement attendris.',
    'Déglacer avec les 10 cl de vin rouge et laisser réduire 2 à 3 minutes.',
    'Ajouter le coulis de tomate, le verre de vin rouge, le paprika, le cumin si désiré et un peu de piment. Mélanger, saler et poivrer.',
    'Couvrir partiellement et laisser mijoter à feu doux environ 45 minutes. Ajouter un peu d’eau en cours de cuisson si la sauce réduit trop.',
    'Égoutter et rincer les haricots rouges, puis les ajouter au chili. Poursuivre la cuisson pendant 15 minutes.',
    'Rectifier l’assaisonnement et servir bien chaud, éventuellement accompagné de riz.',
  ],
  note: 'Pour un goût plus profond, laisser mijoter doucement un peu plus longtemps si le temps le permet.',
}
